var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 712,
    height: 1200,
    viewBox: "0 0 712 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M711.775 0H-0.224609V1200H711.775V0Z",
    fill: "#004660"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -2,
    width: 713,
    height: 1200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M711.775 -2H-0.224609V1198H711.775V-2Z",
    fill: "#033156"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.875 1143.59C202.954 1143.59 199.775 1146.77 199.775 1150.69C199.775 1154.61 202.954 1157.79 206.875 1157.79C210.796 1157.79 213.975 1154.61 213.975 1150.69C213.975 1146.77 210.796 1143.59 206.875 1143.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 1142.67C174.553 1142.67 171.374 1145.85 171.374 1149.77C171.374 1153.69 174.553 1156.87 178.474 1156.87C182.395 1156.87 185.574 1153.69 185.574 1149.77C185.574 1145.85 182.395 1142.67 178.474 1142.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 1142.67C146.155 1142.67 142.976 1145.85 142.976 1149.77C142.976 1153.69 146.155 1156.87 150.076 1156.87C153.997 1156.87 157.176 1153.69 157.176 1149.77C157.176 1145.85 153.997 1142.67 150.076 1142.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.875 1115.19C202.954 1115.19 199.775 1118.37 199.775 1122.29C199.775 1126.21 202.954 1129.39 206.875 1129.39C210.796 1129.39 213.975 1126.21 213.975 1122.29C213.975 1118.37 210.796 1115.19 206.875 1115.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.875 1085.87C202.954 1085.87 199.775 1089.05 199.775 1092.97C199.775 1096.89 202.954 1100.07 206.875 1100.07C210.796 1100.07 213.975 1096.89 213.975 1092.97C213.975 1089.05 210.796 1085.87 206.875 1085.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 1114.27C174.553 1114.27 171.374 1117.45 171.374 1121.37C171.374 1125.29 174.553 1128.47 178.474 1128.47C182.395 1128.47 185.574 1125.29 185.574 1121.37C185.574 1117.45 182.395 1114.27 178.474 1114.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 1084.95C174.553 1084.95 171.374 1088.13 171.374 1092.05C171.374 1095.97 174.553 1099.15 178.474 1099.15C182.395 1099.15 185.574 1095.97 185.574 1092.05C185.574 1088.13 182.395 1084.95 178.474 1084.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 1114.27C146.155 1114.27 142.976 1117.45 142.976 1121.37C142.976 1125.29 146.155 1128.47 150.076 1128.47C153.997 1128.47 157.176 1125.29 157.176 1121.37C157.176 1117.45 153.997 1114.27 150.076 1114.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 1084.95C146.155 1084.95 142.976 1088.13 142.976 1092.05C142.976 1095.97 146.155 1099.15 150.076 1099.15C153.997 1099.15 157.176 1095.97 157.176 1092.05C157.176 1088.13 153.997 1084.95 150.076 1084.95Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.675 1143.59C117.754 1143.59 114.575 1146.77 114.575 1150.69C114.575 1154.61 117.754 1157.79 121.675 1157.79C125.596 1157.79 128.775 1154.61 128.775 1150.69C128.775 1146.77 125.596 1143.59 121.675 1143.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 1142.67C89.3537 1142.67 86.175 1145.85 86.175 1149.77C86.175 1153.69 89.3537 1156.87 93.275 1156.87C97.1962 1156.87 100.375 1153.69 100.375 1149.77C100.375 1145.85 97.1962 1142.67 93.275 1142.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 1142.67C60.9554 1142.67 57.7766 1145.85 57.7766 1149.77C57.7766 1153.69 60.9554 1156.87 64.8766 1156.87C68.7978 1156.87 71.9766 1153.69 71.9766 1149.77C71.9766 1145.85 68.7978 1142.67 64.8766 1142.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.675 1115.19C117.754 1115.19 114.575 1118.37 114.575 1122.29C114.575 1126.21 117.754 1129.39 121.675 1129.39C125.596 1129.39 128.775 1126.21 128.775 1122.29C128.775 1118.37 125.596 1115.19 121.675 1115.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.675 1085.87C117.754 1085.87 114.575 1089.05 114.575 1092.97C114.575 1096.89 117.754 1100.07 121.675 1100.07C125.596 1100.07 128.775 1096.89 128.775 1092.97C128.775 1089.05 125.596 1085.87 121.675 1085.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 1114.27C89.3537 1114.27 86.175 1117.45 86.175 1121.37C86.175 1125.29 89.3537 1128.47 93.275 1128.47C97.1962 1128.47 100.375 1125.29 100.375 1121.37C100.375 1117.45 97.1962 1114.27 93.275 1114.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 1084.95C89.3537 1084.95 86.175 1088.13 86.175 1092.05C86.175 1095.97 89.3537 1099.15 93.275 1099.15C97.1962 1099.15 100.375 1095.97 100.375 1092.05C100.375 1088.13 97.1962 1084.95 93.275 1084.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 1114.27C60.9554 1114.27 57.7766 1117.45 57.7766 1121.37C57.7766 1125.29 60.9554 1128.47 64.8766 1128.47C68.7978 1128.47 71.9766 1125.29 71.9766 1121.37C71.9766 1117.45 68.7978 1114.27 64.8766 1114.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 1084.95C60.9554 1084.95 57.7766 1088.13 57.7766 1092.05C57.7766 1095.97 60.9554 1099.15 64.8766 1099.15C68.7978 1099.15 71.9766 1095.97 71.9766 1092.05C71.9766 1088.13 68.7978 1084.95 64.8766 1084.95Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.875 1055.63C202.954 1055.63 199.775 1058.81 199.775 1062.73C199.775 1066.65 202.954 1069.83 206.875 1069.83C210.796 1069.83 213.975 1066.65 213.975 1062.73C213.975 1058.81 210.796 1055.63 206.875 1055.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 1054.72C174.553 1054.72 171.374 1057.9 171.374 1061.82C171.374 1065.74 174.553 1068.92 178.474 1068.92C182.395 1068.92 185.574 1065.74 185.574 1061.82C185.574 1057.9 182.395 1054.72 178.474 1054.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 1054.72C146.155 1054.72 142.976 1057.9 142.976 1061.82C142.976 1065.74 146.155 1068.92 150.076 1068.92C153.997 1068.92 157.176 1065.74 157.176 1061.82C157.176 1057.9 153.997 1054.72 150.076 1054.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.875 1027.23C202.954 1027.23 199.775 1030.41 199.775 1034.33C199.775 1038.25 202.954 1041.43 206.875 1041.43C210.796 1041.43 213.975 1038.25 213.975 1034.33C213.975 1030.41 210.796 1027.23 206.875 1027.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.875 997.92C202.954 997.92 199.775 1001.1 199.775 1005.02C199.775 1008.94 202.954 1012.12 206.875 1012.12C210.796 1012.12 213.975 1008.94 213.975 1005.02C213.975 1001.1 210.796 997.92 206.875 997.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 1026.32C174.553 1026.32 171.374 1029.5 171.374 1033.42C171.374 1037.34 174.553 1040.52 178.474 1040.52C182.395 1040.52 185.574 1037.34 185.574 1033.42C185.574 1029.5 182.395 1026.32 178.474 1026.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 997C174.553 997 171.374 1000.18 171.374 1004.1C171.374 1008.02 174.553 1011.2 178.474 1011.2C182.395 1011.2 185.574 1008.02 185.574 1004.1C185.574 1000.18 182.395 997 178.474 997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 1026.32C146.155 1026.32 142.976 1029.5 142.976 1033.42C142.976 1037.34 146.155 1040.52 150.076 1040.52C153.997 1040.52 157.176 1037.34 157.176 1033.42C157.176 1029.5 153.997 1026.32 150.076 1026.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.076 997C146.155 997 142.976 1000.18 142.976 1004.1C142.976 1008.02 146.155 1011.2 150.076 1011.2C153.997 1011.2 157.176 1008.02 157.176 1004.1C157.176 1000.18 153.997 997 150.076 997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.675 1055.63C117.754 1055.63 114.575 1058.81 114.575 1062.73C114.575 1066.65 117.754 1069.83 121.675 1069.83C125.596 1069.83 128.775 1066.65 128.775 1062.73C128.775 1058.81 125.596 1055.63 121.675 1055.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 1054.72C89.3537 1054.72 86.175 1057.9 86.175 1061.82C86.175 1065.74 89.3537 1068.92 93.275 1068.92C97.1962 1068.92 100.375 1065.74 100.375 1061.82C100.375 1057.9 97.1962 1054.72 93.275 1054.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 1054.72C60.9554 1054.72 57.7766 1057.9 57.7766 1061.82C57.7766 1065.74 60.9554 1068.92 64.8766 1068.92C68.7978 1068.92 71.9766 1065.74 71.9766 1061.82C71.9766 1057.9 68.7978 1054.72 64.8766 1054.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.675 1027.23C117.754 1027.23 114.575 1030.41 114.575 1034.33C114.575 1038.25 117.754 1041.43 121.675 1041.43C125.596 1041.43 128.775 1038.25 128.775 1034.33C128.775 1030.41 125.596 1027.23 121.675 1027.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.675 997.92C117.754 997.92 114.575 1001.1 114.575 1005.02C114.575 1008.94 117.754 1012.12 121.675 1012.12C125.596 1012.12 128.775 1008.94 128.775 1005.02C128.775 1001.1 125.596 997.92 121.675 997.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 1026.32C89.3537 1026.32 86.175 1029.5 86.175 1033.42C86.175 1037.34 89.3537 1040.52 93.275 1040.52C97.1962 1040.52 100.375 1037.34 100.375 1033.42C100.375 1029.5 97.1962 1026.32 93.275 1026.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.275 997C89.3537 997 86.175 1000.18 86.175 1004.1C86.175 1008.02 89.3537 1011.2 93.275 1011.2C97.1962 1011.2 100.375 1008.02 100.375 1004.1C100.375 1000.18 97.1962 997 93.275 997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 1026.32C60.9554 1026.32 57.7766 1029.5 57.7766 1033.42C57.7766 1037.34 60.9554 1040.52 64.8766 1040.52C68.7978 1040.52 71.9766 1037.34 71.9766 1033.42C71.9766 1029.5 68.7978 1026.32 64.8766 1026.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8766 997C60.9554 997 57.7766 1000.18 57.7766 1004.1C57.7766 1008.02 60.9554 1011.2 64.8766 1011.2C68.7978 1011.2 71.9766 1008.02 71.9766 1004.1C71.9766 1000.18 68.7978 997 64.8766 997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.875 72.2C505.796 72.2 508.975 69.0212 508.975 65.1C508.975 61.1788 505.796 58 501.875 58C497.954 58 494.775 61.1788 494.775 65.1C494.775 69.0212 497.954 72.2 501.875 72.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 73.116C534.197 73.116 537.376 69.9372 537.376 66.016C537.376 62.0948 534.197 58.916 530.276 58.916C526.355 58.916 523.176 62.0948 523.176 66.016C523.176 69.9372 526.355 73.116 530.276 73.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 73.116C562.595 73.116 565.774 69.9372 565.774 66.016C565.774 62.0948 562.595 58.916 558.674 58.916C554.753 58.916 551.574 62.0948 551.574 66.016C551.574 69.9372 554.753 73.116 558.674 73.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.875 100.6C505.796 100.6 508.975 97.4211 508.975 93.4999C508.975 89.5787 505.796 86.3999 501.875 86.3999C497.954 86.3999 494.775 89.5787 494.775 93.4999C494.775 97.4211 497.954 100.6 501.875 100.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.875 129.916C505.796 129.916 508.975 126.737 508.975 122.816C508.975 118.895 505.796 115.716 501.875 115.716C497.954 115.716 494.775 118.895 494.775 122.816C494.775 126.737 497.954 129.916 501.875 129.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 101.516C534.197 101.516 537.376 98.3371 537.376 94.4159C537.376 90.4947 534.197 87.3159 530.276 87.3159C526.355 87.3159 523.176 90.4947 523.176 94.4159C523.176 98.3371 526.355 101.516 530.276 101.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 130.832C534.197 130.832 537.376 127.653 537.376 123.732C537.376 119.811 534.197 116.632 530.276 116.632C526.355 116.632 523.176 119.811 523.176 123.732C523.176 127.653 526.355 130.832 530.276 130.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 101.516C562.595 101.516 565.774 98.3371 565.774 94.4159C565.774 90.4947 562.595 87.3159 558.674 87.3159C554.753 87.3159 551.574 90.4947 551.574 94.4159C551.574 98.3371 554.753 101.516 558.674 101.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 130.832C562.595 130.832 565.774 127.653 565.774 123.732C565.774 119.811 562.595 116.632 558.674 116.632C554.753 116.632 551.574 119.811 551.574 123.732C551.574 127.653 554.753 130.832 558.674 130.832Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.075 72.2C590.996 72.2 594.175 69.0212 594.175 65.1C594.175 61.1788 590.996 58 587.075 58C583.154 58 579.975 61.1788 579.975 65.1C579.975 69.0212 583.154 72.2 587.075 72.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 73.116C619.396 73.116 622.575 69.9372 622.575 66.016C622.575 62.0948 619.396 58.916 615.475 58.916C611.554 58.916 608.375 62.0948 608.375 66.016C608.375 69.9372 611.554 73.116 615.475 73.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 73.116C647.794 73.116 650.973 69.9372 650.973 66.016C650.973 62.0948 647.794 58.916 643.873 58.916C639.952 58.916 636.773 62.0948 636.773 66.016C636.773 69.9372 639.952 73.116 643.873 73.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.075 100.6C590.996 100.6 594.175 97.4211 594.175 93.4999C594.175 89.5787 590.996 86.3999 587.075 86.3999C583.154 86.3999 579.975 89.5787 579.975 93.4999C579.975 97.4211 583.154 100.6 587.075 100.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.075 129.916C590.996 129.916 594.175 126.737 594.175 122.816C594.175 118.895 590.996 115.716 587.075 115.716C583.154 115.716 579.975 118.895 579.975 122.816C579.975 126.737 583.154 129.916 587.075 129.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 101.516C619.396 101.516 622.575 98.3371 622.575 94.4159C622.575 90.4947 619.396 87.3159 615.475 87.3159C611.554 87.3159 608.375 90.4947 608.375 94.4159C608.375 98.3371 611.554 101.516 615.475 101.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 130.832C619.396 130.832 622.575 127.653 622.575 123.732C622.575 119.811 619.396 116.632 615.475 116.632C611.554 116.632 608.375 119.811 608.375 123.732C608.375 127.653 611.554 130.832 615.475 130.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 101.516C647.794 101.516 650.973 98.3371 650.973 94.4159C650.973 90.4947 647.794 87.3159 643.873 87.3159C639.952 87.3159 636.773 90.4947 636.773 94.4159C636.773 98.3371 639.952 101.516 643.873 101.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 130.832C647.794 130.832 650.973 127.653 650.973 123.732C650.973 119.811 647.794 116.632 643.873 116.632C639.952 116.632 636.773 119.811 636.773 123.732C636.773 127.653 639.952 130.832 643.873 130.832Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.875 160.152C505.796 160.152 508.975 156.973 508.975 153.052C508.975 149.131 505.796 145.952 501.875 145.952C497.954 145.952 494.775 149.131 494.775 153.052C494.775 156.973 497.954 160.152 501.875 160.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 161.068C534.197 161.068 537.376 157.889 537.376 153.968C537.376 150.047 534.197 146.868 530.276 146.868C526.355 146.868 523.176 150.047 523.176 153.968C523.176 157.889 526.355 161.068 530.276 161.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 161.068C562.595 161.068 565.774 157.889 565.774 153.968C565.774 150.047 562.595 146.868 558.674 146.868C554.753 146.868 551.574 150.047 551.574 153.968C551.574 157.889 554.753 161.068 558.674 161.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.875 188.552C505.796 188.552 508.975 185.373 508.975 181.452C508.975 177.531 505.796 174.352 501.875 174.352C497.954 174.352 494.775 177.531 494.775 181.452C494.775 185.373 497.954 188.552 501.875 188.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.875 217.868C505.796 217.868 508.975 214.689 508.975 210.768C508.975 206.847 505.796 203.668 501.875 203.668C497.954 203.668 494.775 206.847 494.775 210.768C494.775 214.689 497.954 217.868 501.875 217.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 189.468C534.197 189.468 537.376 186.289 537.376 182.368C537.376 178.447 534.197 175.268 530.276 175.268C526.355 175.268 523.176 178.447 523.176 182.368C523.176 186.289 526.355 189.468 530.276 189.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.276 218.784C534.197 218.784 537.376 215.605 537.376 211.684C537.376 207.763 534.197 204.584 530.276 204.584C526.355 204.584 523.176 207.763 523.176 211.684C523.176 215.605 526.355 218.784 530.276 218.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 189.468C562.595 189.468 565.774 186.289 565.774 182.368C565.774 178.447 562.595 175.268 558.674 175.268C554.753 175.268 551.574 178.447 551.574 182.368C551.574 186.289 554.753 189.468 558.674 189.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.674 218.784C562.595 218.784 565.774 215.605 565.774 211.684C565.774 207.763 562.595 204.584 558.674 204.584C554.753 204.584 551.574 207.763 551.574 211.684C551.574 215.605 554.753 218.784 558.674 218.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.075 160.152C590.996 160.152 594.175 156.973 594.175 153.052C594.175 149.131 590.996 145.952 587.075 145.952C583.154 145.952 579.975 149.131 579.975 153.052C579.975 156.973 583.154 160.152 587.075 160.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 161.068C619.396 161.068 622.575 157.889 622.575 153.968C622.575 150.047 619.396 146.868 615.475 146.868C611.554 146.868 608.375 150.047 608.375 153.968C608.375 157.889 611.554 161.068 615.475 161.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 161.068C647.794 161.068 650.973 157.889 650.973 153.968C650.973 150.047 647.794 146.868 643.873 146.868C639.952 146.868 636.773 150.047 636.773 153.968C636.773 157.889 639.952 161.068 643.873 161.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.075 188.552C590.996 188.552 594.175 185.373 594.175 181.452C594.175 177.531 590.996 174.352 587.075 174.352C583.154 174.352 579.975 177.531 579.975 181.452C579.975 185.373 583.154 188.552 587.075 188.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.075 217.868C590.996 217.868 594.175 214.689 594.175 210.768C594.175 206.847 590.996 203.668 587.075 203.668C583.154 203.668 579.975 206.847 579.975 210.768C579.975 214.689 583.154 217.868 587.075 217.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 189.468C619.396 189.468 622.575 186.289 622.575 182.368C622.575 178.447 619.396 175.268 615.475 175.268C611.554 175.268 608.375 178.447 608.375 182.368C608.375 186.289 611.554 189.468 615.475 189.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 218.784C619.396 218.784 622.575 215.605 622.575 211.684C622.575 207.763 619.396 204.584 615.475 204.584C611.554 204.584 608.375 207.763 608.375 211.684C608.375 215.605 611.554 218.784 615.475 218.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 189.468C647.794 189.468 650.973 186.289 650.973 182.368C650.973 178.447 647.794 175.268 643.873 175.268C639.952 175.268 636.773 178.447 636.773 182.368C636.773 186.289 639.952 189.468 643.873 189.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.873 218.784C647.794 218.784 650.973 215.605 650.973 211.684C650.973 207.763 647.794 204.584 643.873 204.584C639.952 204.584 636.773 207.763 636.773 211.684C636.773 215.605 639.952 218.784 643.873 218.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.7754 149C80.3602 149 106.775 122.585 106.775 90C106.775 57.4152 80.3602 31 47.7754 31C15.1906 31 -11.2246 57.4152 -11.2246 90C-11.2246 122.585 15.1906 149 47.7754 149Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M580.275 338C591.597 338 600.775 328.822 600.775 317.5C600.775 306.178 591.597 297 580.275 297C568.953 297 559.775 306.178 559.775 317.5C559.775 328.822 568.953 338 580.275 338Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M663.775 1231C705.196 1231 738.775 1197.42 738.775 1156C738.775 1114.58 705.196 1081 663.775 1081C622.354 1081 588.775 1114.58 588.775 1156C588.775 1197.42 622.354 1231 663.775 1231Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M695.275 655C719.299 655 738.775 635.524 738.775 611.5C738.775 587.476 719.299 568 695.275 568C671.251 568 651.775 587.476 651.775 611.5C651.775 635.524 671.251 655 695.275 655Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M587.275 1097C596.94 1097 604.775 1089.16 604.775 1079.5C604.775 1069.84 596.94 1062 587.275 1062C577.61 1062 569.775 1069.84 569.775 1079.5C569.775 1089.16 577.61 1097 587.275 1097Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M587.275 1087C591.417 1087 594.775 1083.64 594.775 1079.5C594.775 1075.36 591.417 1072 587.275 1072C583.133 1072 579.775 1075.36 579.775 1079.5C579.775 1083.64 583.133 1087 587.275 1087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M673.275 733C677.969 733 681.775 729.194 681.775 724.5C681.775 719.806 677.969 716 673.275 716C668.581 716 664.775 719.806 664.775 724.5C664.775 729.194 668.581 733 673.275 733Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.275 181C121.969 181 125.775 177.194 125.775 172.5C125.775 167.806 121.969 164 117.275 164C112.581 164 108.775 167.806 108.775 172.5C108.775 177.194 112.581 181 117.275 181Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M673.275 728C675.208 728 676.775 726.433 676.775 724.5C676.775 722.567 675.208 721 673.275 721C671.342 721 669.775 722.567 669.775 724.5C669.775 726.433 671.342 728 673.275 728Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.275 176C119.208 176 120.775 174.433 120.775 172.5C120.775 170.567 119.208 169 117.275 169C115.342 169 113.775 170.567 113.775 172.5C113.775 174.433 115.342 176 117.275 176Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 712,
    height: 1200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.ed44f09ec95c097ba7c53aacfddeef76.svg";
export { ForwardRef as ReactComponent };